import { render, staticRenderFns } from "./ConferenceList.vue?vue&type=template&id=7b618e43&scoped=true&"
import script from "./ConferenceList.vue?vue&type=script&lang=js&"
export * from "./ConferenceList.vue?vue&type=script&lang=js&"
import style1 from "./ConferenceList.vue?vue&type=style&index=1&id=7b618e43&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b618e43",
  null
  
)

export default component.exports